/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
// @material-ui/icons
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import SnackbarContent from "../../components/Snackbar/SnackbarContent.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import TasksCardDeck from './TasksCardDeck';
import t from '../../i18n/translate'

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

const useStyles = makeStyles(styles);

function Notifications(props) {
  const classes = useStyles();
  return (
    <Card>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Activity Summary</h4>
        <p className={classes.cardCategoryWhite}>
          {t("Today Activity") }
          {" "+new Date().toLocaleDateString()}
        </p>
      </CardHeader>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <TasksCardDeck/>
            <br />
            {props.bellTask.length===0?
            <SnackbarContent
            message={t`No task for Today, continue in actuel tasks`}
            color="success"
            />
          :null}
          </GridItem>
        </GridContainer>
        <br />
      </CardBody>
    </Card>
  );
}

const mapStateToProps = (state) => {
  return {
    bellTask: state.bellReducer.task,
    isAuthenticated: state.authReducer.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);